<div class="dialog-padding">
  <h1 mat-dialog-title>{{ data.title || 'Select' }}</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>{{ data.prompt }}</mat-label>
      <mat-select [(ngModel)]="data.selected" id="selectDialog-select-select" name="select" required>
        <mat-option *ngFor="let item of data.list" [value]="item">{{ item[data.accessor] || item }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button id="selectDialog-button-confirm" mat-raised-button color="primary" uzDebounceClick (debounceClick)="apply()">Confirm</button>
  </div>
</div>
